export default "__VITE_ASSET__7044442a__"